import { IndicatorShell } from "src/components-mui/pages/detail/certificate-box/components/indicator-shell/indicator-shell";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";
import { getGlobals } from "src/constants/globals";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

const CERTIFICATE_BOX_INVESTED_CAPITAL_TEST_ID = "certificate-box-invested-capital";

export const CBInvestedCapital = () => {
    const { data } = useCertificateBoxContext();
    const { formatNumber } = useNumberFormatter();

    if (data.wikifolio?.isParadise) {
        return null;
    }

    const totalInvestments = `${getGlobals().currency} ${
        data.keyFigures.totalInvestments.ranking.value ? formatNumber(data.keyFigures.totalInvestments.ranking.value) : 0
    }`;

    const { label } = data.keyFigures.totalInvestments.ranking;

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_INVESTED_CAPITAL_TEST_ID}
            tooltip={data.keyFigures.totalInvestments.tooltip!}
            indicatorName={label}
            indicatorValue={totalInvestments}
        />
    );
};
